import React, { useEffect, useState } from "react";
import { exercisesOptions, fetchData } from "../utils/FetchData"; // Importing necessary functions and data from FetchData file
import ExercisesCard from "./ExerciseCard"; // Importing a component for rendering exercise cards
import { Pagination, Stack } from "@mui/material"; // Importing pagination components from Material-UI library

// Defining a functional component named Exercise, which takes props as input
function Exercise({ setExercises, bodyPart, exercises }) {
  // Initializing state variables using React Hooks
  const [currentPage, setCurrentPage] = useState(1); // State for current page of pagination
  const exercisesPerPage = 12; // Number of exercises to display per page

  // useEffect hook to fetch exercise data when component mounts or bodyPart changes
  useEffect(() => {
    // Async function to fetch exercise data
    const fetchExercisesData = async () => {
      try {
        let exercisesData = []; // Initializing an array to store fetched exercise data

        // Checking if bodyPart is "all" or a specific body part
        if (bodyPart === "all") {
          // Fetching all exercises data if bodyPart is "all"
          exercisesData = await fetchData(
            "https://exercisedb.p.rapidapi.com/exercises",
            exercisesOptions
          );
        } else {
          // Fetching exercises data for a specific body part
          exercisesData = await fetchData(
            `https://exercisedb.p.rapidapi.com/exercises/bodyPart/${bodyPart}`,
            exercisesOptions
          );
        }

        // Setting fetched exercise data using setExercises function passed as prop
        setExercises(exercisesData);
      } catch (error) {
        // Handling errors if any occur during data fetching
        console.error("Error fetching exercises data:", error);
      }
    };

    // Calling the fetchExercisesData function when component mounts or bodyPart changes
    fetchExercisesData();
  }, [bodyPart, setExercises]); 
// Dependency array to ensure useEffect runs when bodyPart or setExercises change

  // Calculating indexes of first and last exercises to display on current page
  const indexOfLastExercise = currentPage * exercisesPerPage;
  const indexOfFirstExercise = indexOfLastExercise - exercisesPerPage;

  // Slicing the exercises array to get exercises for the current page
  const currentExercises = exercises?.slice(
    indexOfFirstExercise,
    indexOfLastExercise
  );

  // Function to handle pagination change
  const paginate = (e, value) => {
    setCurrentPage(value); // Updating currentPage state to the selected page number
    window.scrollTo({ top: 1250, behavior: "smooth" }); // Smooth scrolling to the top of the page
  };

  // Rendering the Exercise component
  return (
    <div className="flex md:w-4/5 
    items-center 
    md:items-start 
    justify-center
     md:justify-start 
     flex-col m-auto">
      {/* Heading to indicate that exercise results are being shown */}
      <p className="font-bold uppercase text-4xl">Showing Results</p>
      {/* Rendering exercise cards */}
      <div className="flex w-full flex-wrap gap-4 
      items-center md:items-start justify-center md:justify-start mt-5">
        {currentExercises?.map((item, index) => (
          <ExercisesCard key={index} exercises={item} />
        ))}
      </div>
      
      {/* Pagination component */}
      <div className="w-full m-auto">
        <Stack mt="50px" mb="20px" alignItems="center">
          {exercises?.length > 9 && ( // Checking if there are more than 9 exercises
            <Pagination
              color="standard"
              shape="rounded"
              defaultPage={1}
              count={Math.ceil(exercises.length / exercisesPerPage)} // Calculating total number of pages
              page={currentPage} // Current page number
              onChange={paginate} // Function to handle page change
              size="large"
              variant="outlined"
            />
          )}
        </Stack>
      </div>
    </div>
  );
}

// Exporting the Exercise component as the default export
export default Exercise;
